const { __ } = wp.i18n;

const i18n = {};

i18n.PENDING = __( 'Pending', 'gallery-custom-links' );
i18n.RENAME = __( 'Rename', 'gallery-custom-links' );
i18n.TITLE = __( 'Title', 'gallery-custom-links' );
i18n.SAME_PAGE = __( 'Same page', 'gallery-custom-links' );
i18n.NEW_PAGE = __( 'New page', 'gallery-custom-links' );
i18n.LINK_URL = __( 'Link URL', 'gallery-custom-links' );
i18n.LINK_TARGET = __( 'Link Target', 'gallery-custom-links' );
i18n.LINK_REL = __( 'Link Rel', 'gallery-custom-links' );
i18n.ARIAL_LABEL = __( 'Arial Label', 'gallery-custom-links' );

export default i18n;

